import React, {Component} from "react";
import classes from './NewPost.module.css'
import ReactQuill from "react-quill";
import 'react-quill/dist/quill.snow.css'
import {
    Container,
    Row,
    Col,
    Card,
    CardHeader,
    CardBody,
    FormGroup,
    Label,
    Input,
    Button,
    InputGroup,
    ButtonGroup
} from 'reactstrap'
import firebase from "../../Config/firebase";
import AsyncSelect from 'react-select/async';
import Compressor from 'compressorjs'
import {v4 as uuidv4} from 'uuid'
import {Link, withRouter} from 'react-router-dom'
import {
    MDBAlert,
    MDBBreadcrumb,
    MDBBreadcrumbItem, MDBBtn, MDBBtnGroup,
    MDBCard,
    MDBCardBody,
    MDBCol,
    MDBContainer,
    MDBListGroup,
    MDBRow
} from "mdbreact";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowLeft} from "@fortawesome/free-solid-svg-icons";
import common from '../../Utils/common.module.css'
import ReactQuillEditorCss from "../../Utils/ReactQuillEditor.module.css";
import {isAuth, isIncludeBlob} from "../../Utils/firebaseUtils";
import Select from "react-select";
import {connect} from "react-redux";
import PollDisplay from "../Poll/PollDisplay";
import RealtimePoll from "../Poll/RealtimePoll";

const db = firebase.firestore()
const storageRef = firebase.storage()

class NewPost extends Component {
    constructor(props) {
        super(props);
        this.poll = React.createRef();
        this.state = {
            community: {},
            schoolName: '',
            post: {
                title: '',
                content: '',
                createDate: new Date(),
                FeatureImage: '',
                isPublish: true,
                lastModified: new Date(),
                createUserID: '',
                communityID: '',
                createUserName: '',
                isPoll: false,
                votedList: [],
                likeCount: 0,
                dislikeCount: 0,
                netCount: 0
            },
            newPoll: {
                pollTitle: '',
                pollOption: [],
            },
            selectedTag: [],

            isLoadedUserName: false,
            userName: [],
            isIncludeBlob: false
        }
    }

    modules = {
        toolbar: {
            container: [[{'header': [1, 2, false]}],
                ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                [{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}],
                ['link', 'image'],
                ['clean'], ['code-block']
            ],
            handlers: {
                'image': () => this.quillImageCallBack()
            },
            clipboard: {
                matchVisual: false
            }
        }
    }

    formats = [
        'header',
        'bold', 'italic', 'underline', 'strike', 'blockquote',
        'list', 'bullet', 'indent',
        'link', 'image'
    ]

   async  componentDidMount() {
        if (isAuth(this.props.auth)) {
            this.setState({
                post: {
                    ...this.state.post,
                    createUserID: this.props.auth.uid
                }
            })
            this.getCustomClaim(this.props.auth)
            if (typeof this.props.location.state !== 'undefined') {
                if(typeof this.props.location.state.community !== 'undefined'){
                    const communityID = this.props.location.state.community.communityID
                    const schoolName = this.props.location.state.community.titleCHI !== '' ? this.props.location.state.community.titleCHI : this.props.location.state.community.title
                    this.setState({
                        post: {
                            ...this.state.post,
                            communityID: communityID,
                            createUserID: this.props.auth.uid
                        },
                        schoolName: schoolName
                    })
                }
               else if(typeof this.props.location.state.communityID !== 'undefined'){
                    const communityID = this.props.location.state.communityID
                    const communityName = await this.getCommunityNameByID(this.props.location.state.communityID)
                    this.setState({
                        post: {
                            ...this.state.post,
                            communityID: communityID,
                            createUserID: this.props.auth.uid
                        },
                        schoolName: communityName
                    })
                }
            }
        } else {
            this.props.history.push({pathname: "/login"})
        }

    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (this.props.auth !== nextProps.auth) {
            if (isAuth(nextProps.auth)) {
                this.getCustomClaim(nextProps.auth)
                this.setState({
                    post: {
                        ...this.state.post,
                        createUserID: nextProps.auth.uid
                    }
                })
            }
        }
    }

    getCommunityNameByID = (cid) => {
        return new Promise((resolve, reject) => {
            db.collection("Community")
                .doc(cid)
                .get()
                .then( doc => {
                    if(doc.exists){
                        return resolve(doc.data().titleCHI !== '' ? doc.data().titleCHI : doc.data().title)
                    }
                })

        })

    }

    getCustomClaim = (auth) => {
        if (isAuth(auth)) {
            firebase.auth().currentUser.getIdTokenResult()
                .then(idTokenResult => {
                    console.log(idTokenResult)
                    if (idTokenResult.claims.hasOwnProperty("userName") && Array.isArray(idTokenResult.claims.userName)) {
                        let newArr = []
                        idTokenResult.claims.userName.map(e => {
                            newArr.push({
                                value: decodeURIComponent(escape(e)),
                                label: decodeURIComponent(escape(e))
                            })
                        })
                        // console.log(newArr)
                        this.setState({
                            userName: newArr,
                            post: {
                                ...this.state.post,
                                createUserName: newArr[0].label
                            }
                        }, () => {
                            this.setState({
                                isLoadedUserName: true
                            })
                        })
                    } else {
                        this.setState({
                            userName: []
                        }, () => {
                            this.setState({
                                isLoadedUserName: true
                            })
                        })
                    }
                })
        }
    }

    onChangePostTitle = (value) => {
        this.setState({
            post: {
                ...this.state.post,
                title: value
            }
        })
    }

    onChangePostContent = (value) => {
        this.setState({
            post: {
                ...this.state.post,
                content: value
            }
        })
    }

    onChangeCommunityID = (value) => {
        console.log(value)
        this.setState({
            post: {
                ...this.state.post,
                communityID: value
            }
        })
    }

    onChangePublish = (val) => {
        this.setState({
            post: {
                ...this.state.post,
                isPublish: val === "True"
            }
        })
    }

    onChangePostUserName = (userName) => {
        this.setState({
            post: {
                ...this.state.post,
                createUserName: userName
            }
        })
    }

    submitPost = () => {
        if (!isIncludeBlob(this.state.post.content)) {
            this.setState({
                isIncludeBlob: false
            })
            const post = this.state.post
            db.collection('Post')
                .add(post)
                .then(res => {

                    post.id = res.id
                    if (this.state.post.isPoll) {
                        /* db.collection("Post").doc(res.id)
                             .collection('PollOption')
                             .add(this.state.newPoll.pollOption).then(r => {

                         })*/
                        for (let i = 0; i < this.state.newPoll.pollOption.length; i++) {
                            db.collection("Post").doc(res.id).collection('PollOption')
                                .add(this.state.newPoll.pollOption[i]).then(doc => {
                                //console.log(this.state.newPoll.pollOption[i])
                            })
                        }

                    }
                    this.props.history.push({
                        pathname: '/post/' + res.id,
                        state: {post: post}
                    })

                })
                .catch(err => console.log(err))
        } else {
            this.setState({
                isIncludeBlob: true
            })
        }
    }

    startToSearch = async (searchStr) => {
        console.log(searchStr)
        return await new Promise((resolve, reject) => {
            fetch("/api/search/community", {
                method: 'POST',
                headers: {"Content-Type": "application/json"},
                body: JSON.stringify({
                    searchStr: searchStr
                })
            }).then((res) => res.json()).then((searchResult) => {
                const allResult = []
                if (searchResult.length !== 0) {
                    searchResult.map((s, index) => {
                        console.log(s)
                        allResult.push({
                            value: s.objectID,
                            label: s.titleCHI !== null ? s.titleCHI : "" + s.title !== null ? s.title : ""
                        })
                    })
                    return resolve(allResult)
                }
            })
        })
    }


    fileCompress = (file) => {
        return new Promise((resolve, reject) => {
            console.log(file)
            new Compressor(file, {
                file: 'File',
                quality: 0.5,
                maxWidth: 640,
                maxHeight: 640,
                success(file) {
                    return resolve({
                        success: true,
                        file: file
                    })
                },
                error(err) {
                    return resolve({
                        success: false,
                        message: err.message
                    })
                }
            })
        })
    }

    onCheckboxClick = (selected) => {
        if (selected === 'poll') {
            if (this.state.post.isPoll === false) {
                this.setState({
                    post: {
                        ...this.state.post,
                        isPoll: true,
                        pollTitle: this.state.newPoll.pollTitle
                    }

                })
            } else {
                this.setState({
                    post: {
                        ...this.state.post,
                        isPoll: false,
                        pollTitle: ''
                    }
                })
            }
        }
    }

    quillImageCallBack = () => {
        const input = document.createElement('input')
        input.setAttribute('type', 'file')
        input.setAttribute('accept', 'image/*')
        input.click()
        input.onchange = async () => {
            const file = input.files[0]
            const compressState = await this.fileCompress(file)
            if (compressState.success) {
                const fileName = uuidv4()
                storageRef.ref().child('Post/' + fileName).put(compressState.file)
                    .then(async snapshot => {
                        const downloadURL = await storageRef.ref().child('Post/' + fileName).getDownloadURL()
                        console.log(downloadURL)
                        let quill = this.quill.getEditor()
                        const range = quill.getSelection(true)
                        quill.insertEmbed(range.index, 'image', downloadURL)
                    })
            }
        }
    }

    onChangePollTitle = (val) => {

        this.setState({
            newPoll: {
                ...this.state.newPoll,
                pollTitle: val
            },
            post: {
                ...this.state.post,
                pollTitle: this.state.newPoll.pollTitle
            }
        }, () => {
            console.log(this.state.newPoll)
        })
    }

    changeOptionName = (editOption, index, options) => {

        options[index] = editOption

        this.setState({
            newPoll: {
                ...this.state.newPoll,
                pollOption: options
            }
        }, () => {
            console.log(this.state.newPoll)
        })
    }

    deleteOption = async (index, optionUID) => {
        this.state.newPoll.pollOption.splice(index, 1)
        const options = this.state.newPoll.pollOption
        this.setState({
            newPoll: {
                ...this.state.newPoll,
                pollOption: options
            }
        }, () => {
            console.log(this.state.newPoll)
        })
    }
    addOption = async (newOption) => {
        const newArr = this.state.newPoll.pollOption.concat(newOption)
        this.setState({
            newPoll: {
                ...this.state.newPoll,
                pollOption: newArr
            }
        }, () => {
            console.log(this.state.newPoll)
        })
    }

    render() {
        return (
            <MDBContainer>
                <MDBRow>
                    <MDBCol xl={9} lg={9} md={8} sm={12} xs={12}>
                        <MDBCard className={classes.AritlceContainer}>
                            <MDBCardBody>
                                <h2 className={classes.SectionTitle}>New Post</h2>
                                <FormGroup>
                                    {
                                        typeof this.props.location.state == 'undefined' ?
                                            <div>
                                                <Label className={classes.Label}>選擇學校</Label>
                                                <AsyncSelect
                                                    loadOptions={this.startToSearch}
                                                    cacheOptions
                                                    onChange={(e) => {
                                                        this.onChangeCommunityID(e.value)
                                                    }}
                                                />
                                                {/*<p>Selected tag:</p>*/}
                                            </div>
                                            :
                                            <div>
                                                <Label className={classes.Label}>學校</Label>
                                                <inputGroup>
                                                    <Input type='text'
                                                           disabled='true'
                                                           value={this.state.schoolName}
                                                    />
                                                </inputGroup>
                                            </div>
                                    }
                                </FormGroup>
                                {
                                    this.state.selectedTag.map(e => {
                                        return (
                                            <li key={e.value}>
                                                {e.label}
                                            </li>
                                        )
                                    })
                                }
                                {/*<FormGroup>*/}
                                {/*    <Label className={classes.Label}>分類</Label>*/}
                                {/*    <Input type='select' name='category' id='category'>*/}
                                {/*        <option>教程</option>*/}
                                {/*        <option>教學配套</option>*/}
                                {/*        <option>學校環境</option>*/}
                                {/*        <option>興趣班</option>*/}
                                {/*        <option>E-Learning</option>*/}
                                {/*    </Input>*/}
                                {/*</FormGroup>*/}
                                {/*<FormGroup>*/}
                                {/*    <Label className={classes.Label}>Publish</Label>*/}
                                {/*    <Input type='select' name='publish' id='publish'*/}
                                {/*           onChange={(e)=>this.onChangePublish(e.target.value)}*/}
                                {/*    >*/}
                                {/*        <option>True</option>*/}
                                {/*        <option>False</option>*/}
                                {/*    </Input>*/}
                                {/*</FormGroup>*/}
                                <FormGroup>
                                    <Label className={classes.Label}>發文標題</Label>
                                    <Input type='text' name='postTitle' id='postTitle' placeholder=''
                                           onChange={(e) => this.onChangePostTitle(e.target.value)}
                                           value={this.state.post.title}
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <Label className={classes.Label}>發文內容</Label>
                                    <div className={ReactQuillEditorCss.ReactQuillEditor}>
                                        <ReactQuill
                                            ref={(el) => this.quill = el}
                                            value={this.state.post.content}
                                            onChange={(e) => this.onChangePostContent(e)}
                                            theme='snow'
                                            modules={this.modules}
                                            formats={this.formats}
                                        />
                                    </div>
                                </FormGroup>


                                <div>
                                    {this.state.post.isPoll ?
                                        <RealtimePoll
                                            auth={this.props.auth}
                                            onChangePollTitle={this.onChangePollTitle}
                                            changeOptionName={this.changeOptionName}
                                            deleteOption={this.deleteOption}
                                            addOption={this.addOption}
                                            ref={(el) => this.poll = el}/>
                                        : ''}
                                </div>
                            </MDBCardBody>
                        </MDBCard>
                    </MDBCol>
                    <MDBCol xl={3} lg={3} md={4} sm={12} xs={12}>

                        <Card className={classes.FunctionalCard}>
                            <CardHeader>
                                使用身份
                            </CardHeader>
                            <CardBody>

                                {
                                    this.state.isLoadedUserName ?
                                        <Select options={this.state.userName}
                                                className={classes.Select}
                                                value={{
                                                    label: this.state.post.createUserName,
                                                    value: this.state.post.createUserName
                                                }}
                                                onChange={(e) => this.onChangePostUserName(e.value)}/>
                                        : 'loading'
                                }


                            </CardBody>
                        </Card>

                        <Card className={classes.FunctionalCard}>
                            <CardHeader>
                                更多功能
                            </CardHeader>
                            <CardBody>
                                <MDBBtnGroup>
                                    <MDBBtn color="primary" onClick={() => this.onCheckboxClick('poll')}
                                            active={this.state.post.isPoll}>
                                        投票
                                    </MDBBtn>

                                </MDBBtnGroup>


                            </CardBody>
                        </Card>

                        <div className={classes.FunctionalCardSubmition}>
                            <Button color='link'
                                    className={classes.SubmitPostBtn}
                                    onClick={(e) => this.submitPost()}>
                                發送
                            </Button>

                            {
                                this.state.isIncludeBlob ?
                                    <MDBAlert color='danger'>
                                        [未儲存]我們不容許文章圖片是直接貼上
                                    </MDBAlert>
                                    : ''
                            }
                        </div>


                        <div className={classes.FloatBtnContainer}>
                            <Button color='link'
                                    className={classes.SubmitPostFloatBtn}
                                    onClick={(e) => this.submitPost()}>
                                發送
                            </Button>

                            {
                                this.state.isIncludeBlob ?
                                    <MDBAlert color='danger'>
                                        [未儲存]我們不容許文章圖片是直接貼上
                                    </MDBAlert>
                                    : ''
                            }
                        </div>

                    </MDBCol>
                </MDBRow>

            </MDBContainer>
        )
    }
}

const enhance = connect(
    ({firebase: {auth, profile}}) => ({
        auth,
        profile
    })
)

export default enhance(withRouter(NewPost))